module.exports = __webpack_public_path__ + "img/gb-nir.2e9c71c7.svg";